import { i18n } from 'maeng-utils/locale'
import ko from '@/locales/ko'

const resources = {
  ko: {
    translation: ko,
  },
}

i18n.init({
  resources,
  lng: 'ko', // 기본 설정 언어, 'cimode'로 설정할 경우 키 값으로 출력된다.
  fallbackLng: 'ko', // 번역 파일에서 찾을 수 없는 경우 기본 언어
  interpolation: {
    escapeValue: false,
  },
  returnObjects: true, // 기본 값을 true로 설정
})

export default i18n
